import * as PIXI from "pixi.js";
import {LinearMotionWithAccelerationRendererInstance} from "./LinearMotionWithAccelerationRendererInstance";

export class LinearMotionWithAcceleration {

    private linearMotionWithAccelerationRendererInstances: Array<LinearMotionWithAccelerationRendererInstance> = [];

    constructor() {

    }

    public async move(container: PIXI.Container,
                      startPoint: PIXI.Point,
                      finishPoint: PIXI.Point): Promise<void> {
        for (let i = 0; i < this.linearMotionWithAccelerationRendererInstances.length; i++) {
            if (!this.linearMotionWithAccelerationRendererInstances[i].isUsed()) {
                await this.linearMotionWithAccelerationRendererInstances[i].move(container, startPoint, finishPoint);
                return;
            }
        }

        const newInstance = new LinearMotionWithAccelerationRendererInstance();
        this.linearMotionWithAccelerationRendererInstances.push(newInstance);
        await this.move(container, startPoint, finishPoint);
    }
}



// WEBPACK FOOTER //
// ./src/app/LinearMotionWithAcceleration.ts